import { forwardRef } from "react";
import styles from "../../styles/input-search.module.scss";
import { If } from "./control-statements";

export const InputSearch = forwardRef(function InputSearch(
  {
    type,
    name,
    placeholder,
    value,
    onBlur,
    onFocus,
    autoFocus,
    className,
    onChange,
    occurrences,
    design = "one",
    onClear,
  },
  ref,
) {
  return (
    <div className={`${styles.inputSearchContainer} ${className}`}>
      <input
        ref={ref}
        id={name}
        type={type}
        name={name}
        placeholder={placeholder}
        onBlur={onBlur}
        onFocus={onFocus}
        value={value}
        autoFocus={autoFocus}
        className={styles[`design-${design}`]}
        onChange={onChange}
      />
      <span className={styles.icon}>
        <i className="far fa-search" />
      </span>
      <If cond={!!onClear && !!value}>
        <span className={styles.clear} onClick={onClear}>
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="12.8" height="12.8" rx="6.4" fill="#292929" />
            <path
              d="M8.80104 4.53334L9.06771 4.26667L8.53438 3.73491L8.26771 4.00157L6.40104 5.86824L4.53438 4L4.26771 3.73334L3.73594 4.26667L4.00261 4.53334L5.86928 6.4L4.00104 8.26667L3.73438 8.53334L4.26771 9.0651L4.53438 8.79844L6.40104 6.93177L8.26771 8.8L8.53438 9.06667L9.06614 8.53334L8.79947 8.26667L6.93281 6.4L8.80104 4.53334Z"
              fill="#6F767E"
            />
          </svg>
        </span>
      </If>
      {!!occurrences && (
        <span className={styles.occurrences}>{occurrences}</span>
      )}
    </div>
  );
});
